/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import _ from 'lodash';
export var NotificationSeverity;
(function (NotificationSeverity) {
    NotificationSeverity["INFO"] = "info";
    NotificationSeverity["WARNING"] = "warning";
    NotificationSeverity["SUCCESS"] = "success";
    NotificationSeverity["ERROR"] = "error";
})(NotificationSeverity || (NotificationSeverity = {}));
export var BidRequestEventNotification;
(function (BidRequestEventNotification) {
    BidRequestEventNotification["CREATED"] = "created";
    BidRequestEventNotification["NEW_VERSION"] = "new_version";
    BidRequestEventNotification["NEW_VERSION_ORIG"] = "new_version_orig";
    BidRequestEventNotification["INPUTS_REVIEWED"] = "inputs_reviewed";
    BidRequestEventNotification["ADD_ENG_INPUTS"] = "add_eng_inputs";
    BidRequestEventNotification["ADD_ENG_CONFIGS"] = "add_eng_configs";
    BidRequestEventNotification["SIMULATE_ENG_SCENARIOS"] = "simulate_eng_scenarios";
    BidRequestEventNotification["REQUEST_SCENARIO_VARIANTS"] = "request_scenario_variants";
    BidRequestEventNotification["ADD_PRICING_SCENARIOS"] = "add_pricing_scenarios";
    BidRequestEventNotification["ADD_PRICING_VARIANTS"] = "add_pricing_variants";
    BidRequestEventNotification["COMPLETED"] = "completed";
})(BidRequestEventNotification || (BidRequestEventNotification = {}));
export const formatUserStr = (username, opts) => {
    if (opts?.userEmail?.split('@')[0] === username) {
        return opts.possessive ? 'Your' : 'You';
    }
    const nameList = username.split('.').map((x) => _.upperFirst(x));
    const userName = opts?.firstNameOnly ? nameList[0] : nameList.join(' ');
    if (opts?.possessive) {
        return userName.at(-1) === 's' ? `${userName}'` : `${userName}'s`;
    }
    return userName;
};
//# sourceMappingURL=notifications.js.map